import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    color: "#193446",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M17.088 2.204a.7.7 0 0 1 .987 0l3.72 3.721a.7.7 0 0 1 0 .987L9.239 19.47a.7.7 0 0 1-.243.158l-6.047 2.325a.698.698 0 0 1-.901-.901l2.325-6.047a.7.7 0 0 1 .158-.243zm-.846 2.82 2.735 2.734 1.339-1.34-2.735-2.734zm1.748 3.72L15.256 6.01 6.01 15.256l2.734 2.734zM7.492 18.711l-2.203-2.203-1.377 3.58z" fill="currentColor"/>' }
  })
);